import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { CallbackModal } from '../components/CallbackModal';
import { MapPin, Star, Scan, Languages, Calendar, MessageCircle, Phone, CheckCircle2, ArrowRight, Plus, Minus, ShieldCheck, CreditCard, Clock, UserCheck } from 'lucide-react';
import { Link } from 'react-router-dom';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const TELEGRAM_URL = 'https://t.me/dentico_clinic';
const MAPS_URL = 'https://maps.app.goo.gl/Fhof2j1jnLA3ffqT6';
const MAPS_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1241.0181846982155!2d-0.104187760804084!3d51.53089276153758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760f7c6534e077%3A0xa54a590bd3b2a149!2sDentico%20Clinic%20-%20Private%20Dentist%20in%20Angel%2C%20Islington!5e0!3m2!1suk!2suk!4v1769722166469!5m2!1suk!2suk';
function TelegramIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} data-id="element-2204" data-mp="1x4a7zgbyirjo">
      <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" data-id="element-2205" data-mp="1j623mnclcnyh" />
    </svg>;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onToggle
}: {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-gray-100 last:border-b-0" data-id="element-2206" data-mp="cc4njuiwed0d">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-4 text-left focus:outline-none group" data-id="element-2207" data-mp="7kw9gl6mi3gv">
        <span className="text-lg font-medium text-gray-900 group-hover:text-forest-700 transition-colors" data-id="element-2208" data-mp="2lt5z56ak5b0">
          {question}
        </span>
        <span className={`flex-shrink-0 ml-4 w-6 h-6 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-forest-600 text-white' : 'bg-stone-100 text-gray-400'}`} data-id="element-2209" data-mp="v9xc1rsryke8">
          {isOpen ? <Minus className="w-4 h-4" data-id="element-2210" data-mp="lazp2tazyyxc" /> : <Plus className="w-4 h-4" data-id="element-2211" data-mp="gcy9wjgozjr5" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0'}`} data-id="element-2212" data-mp="gf0xkwudh0sp">
        <p className="text-gray-600 leading-relaxed" data-id="element-2213" data-mp="31247zj3hen7e">{answer}</p>
      </div>
    </div>;
}
export function ImplantyLondonRuPage() {
  const [isCallbackOpen, setIsCallbackOpen] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };
  const faqs = [{
    q: 'Сколько стоит имплантация зуба в Лондоне?',
    a: 'Стоимость имплантации зависит от клинической ситуации, типа импланта и необходимости дополнительных процедур (например, костная пластика). После консультации мы составляем прозрачный план лечения и смету.'
  }, {
    q: 'Больно ли ставить имплант?',
    a: 'Процедура проводится под местной анестезией. Во время установки импланта большинство пациентов не чувствуют боли, а после — возможен дискомфорт, который контролируется рекомендациями и обезболиванием.'
  }, {
    q: 'Сколько времени занимает имплантация?',
    a: 'Сроки зависят от случая. Обычно сначала проводится консультация и диагностика, затем установка импланта, а после периода заживления — установка коронки. Точный график определяется индивидуально.'
  }, {
    q: 'Подходит ли имплантация, если зуб давно отсутствует?',
    a: 'Да, но может потребоваться оценка состояния кости. Во время консультации мы проверяем объем кости и при необходимости обсуждаем варианты восстановления.'
  }, {
    q: 'Можно ли поставить имплант за один визит?',
    a: 'Иногда возможна одномоментная установка (immediate loading), но чаще требуется период заживления для интеграции импланта. Это определяется после тщательной диагностики.'
  }, {
    q: 'Какие импланты вы используете?',
    a: 'Мы работаем с проверенными системами имплантов премиум-класса, которые имеют долгосрочную гарантию и высокий процент приживления.'
  }, {
    q: 'Можно ли получить консультацию на русском?',
    a: 'Да, в Dentico Clinic возможно общение на русском языке во время консультации и лечения.'
  }, {
    q: 'Где находится клиника?',
    a: 'Dentico Clinic расположена в Angel / Islington, Central London (EC1V). Адрес: 360–364 City Road, London EC1V 2PY, рядом с Angel Station.'
  }];
  // Schemas
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(faq => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a
      }
    }))
  };
  const procedureSchema = {
    '@context': 'https://schema.org',
    '@type': 'MedicalProcedure',
    name: 'Dental Implants',
    description: 'Surgical placement of dental implants to replace missing teeth.',
    procedureType: 'http://schema.org/SurgicalProcedure',
    provider: {
      '@type': 'Dentist',
      name: 'Dentico Clinic',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '360-364 City Road',
        addressLocality: 'London',
        postalCode: 'EC1V 2PY',
        addressCountry: 'GB'
      }
    }
  };
  return <Layout data-id="element-2214" data-mp="1ypkb0pazc0gv">
      <CallbackModal isOpen={isCallbackOpen} onClose={() => setIsCallbackOpen(false)} data-id="element-2215" data-mp="1yq2ea5w27eya" />

      {/* Structured Data */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(faqSchema)
    }} data-id="element-2216" data-mp="1p0slente5s94" />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(procedureSchema)
    }} data-id="element-2217" data-mp="1k1g0w9pzsx9p" />

      {/* 1. HERO SECTION */}
      <section className="relative bg-[#F8F5F0] overflow-hidden" data-id="element-2218" data-mp="1b080nm3x1mcz">
        <div className="absolute inset-0 bg-[#EFE8DE] -skew-y-3 origin-top-left transform translate-y-20" data-id="element-2219" data-mp="161y5hbi6ylrd" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16 lg:pt-20 lg:pb-24 relative" data-id="element-2220" data-mp="113mv8znzi98m">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-2221" data-mp="30gh9jiidsxbi">
            <div className="space-y-6" data-id="element-2222" data-mp="2vh4nv138xwai">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#EFE8DE] text-[#2F4A3F] border border-[#D8C4A8] text-sm font-medium" data-id="element-2223" data-mp="2vi5yx5k9iis8">
                <span className="relative flex h-2 w-2" data-id="element-2224" data-mp="37zqk3f2mj225">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-forest-600 opacity-75" data-id="element-2225" data-mp="37y5nzl0nvb26"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-forest-700" data-id="element-2226" data-mp="3cst2qs5v4r3k"></span>
                </span>
                Имплантация зубов в Лондоне
              </div>

              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2B2D2F] leading-tight tracking-tight" data-id="element-2227" data-mp="2k3m4luabm3iu">
                Имплантация зубов в Лондоне –{' '}
                <span className="text-forest-700" data-id="element-2228" data-mp="2tyxp6t8eu4yi">Dentico Clinic</span>
                <br data-id="element-2229" data-mp="2yzlb50hs7vlv" />
                <span className="text-2xl sm:text-3xl font-medium text-stone-500 mt-2 block" data-id="element-2230" data-mp="2z03f6jaore4c">
                  (Angel, Islington)
                </span>
              </h1>

              <p className="text-lg text-gray-600 max-w-lg leading-relaxed" data-id="element-2231" data-mp="e8kv8vf0pg5r">
                Восстановление утраченных зубов с помощью современных имплантов.
                Консультация на русском языке, цифровая диагностика и прозрачный
                план лечения.
              </p>

              {/* Trust Badges */}
              <div className="flex flex-wrap gap-3 text-sm font-medium text-[#2F4A3F]" data-id="element-2232" data-mp="193qbv5h5kisq">
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-2233" data-mp="14borew9tzlrm">
                  <Star className="w-4 h-4 text-yellow-400 fill-current" data-id="element-2234" data-mp="1i1s6n3aamf7k" />
                  5★ Google Reviews
                </div>
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-2235" data-mp="1e447fo1ki09v">
                  <MapPin className="w-4 h-4 text-[#2F4A3F]" data-id="element-2236" data-mp="1n1y10r7y6ftc" />
                  Angel, EC1V
                </div>
                <div className="flex items-center gap-1.5 bg-[#F8F5F0] px-3 py-1.5 rounded-lg border border-[#D8C4A8] shadow-sm" data-id="element-2237" data-mp="3ttywy1y594jm">
                  <Languages className="w-4 h-4 text-[#2F4A3F]" data-id="element-2238" data-mp="3ovnkrkkdmhy8" />
                  Русский язык
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 pt-4" data-id="element-2239" data-mp="29almw1fbtc20">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2240" data-mp="29cy1q5psf6au">
                  <Button variant="primary" size="lg" className="w-full gap-2" data-id="element-2241" data-mp="1ziz3viwqy8op">
                    <Calendar className="w-5 h-5" data-id="element-2242" data-mp="1ljprkubnvyq0" />
                    Записаться на консультацию
                  </Button>
                </a>
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2243" data-mp="1bncv5ooqf6rk">
                  <Button variant="whatsapp" size="lg" className="w-full gap-2" data-id="element-2244" data-mp="361dv6cw0pzt8">
                    <MessageCircle className="w-5 h-5" data-id="element-2245" data-mp="35zb37nbb1wlv" />
                    WhatsApp
                  </Button>
                </a>
              </div>
            </div>

            <div className="relative" data-id="element-2246" data-mp="1kh8f41a5pnxp">
              <div className="absolute inset-0 bg-[#D8C4A8] rounded-3xl transform rotate-3 blur-sm opacity-30" data-id="element-2247" data-mp="1p9jf144wd9q9"></div>
              <img src="https://images.unsplash.com/photo-1598256989800-fe5f95da9787?auto=format&fit=crop&w=1200&q=80" alt="Имплантация зубов - Dentico Clinic London" className="relative rounded-3xl shadow-2xl object-cover h-[300px] sm:h-[400px] lg:h-[500px] w-full" data-id="element-2248" data-mp="1al59glg3j760" />
            </div>
          </div>
        </div>
      </section>

      {/* 2. WHAT ARE IMPLANTS */}
      <section className="py-16 bg-white" data-id="element-2249" data-mp="1tabnhv5y3alh">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2250" data-mp="1tdhejfy4wmju">
          <div className="text-center mb-10" data-id="element-2251" data-mp="1y8mwk3of1h2n">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-2252" data-mp="hw7rykjpleeb">
              Что такое дентальная имплантация?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-2253" data-mp="mw3vkiohv3tc">
              Дентальная имплантация — это самый современный метод
              восстановления утраченных зубов, который позволяет вернуть не
              только эстетику улыбки, но и полную жевательную функцию. Имплант —
              это титановый корень, который устанавливается в кость челюсти и
              служит надежной опорой для коронки или мостовидного протеза.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mt-4" data-id="element-2254" data-mp="2icc2vfxjxuo2">
              В отличие от съемных протезов, импланты ощущаются и функционируют
              как собственные зубы. Они предотвращают атрофию костной ткани и не
              требуют обтачивания соседних здоровых зубов, что делает их лучшим
              долгосрочным решением для восстановления зубного ряда.
            </p>
          </div>
        </div>
      </section>

      {/* 3. PROCESS */}
      <section className="py-16 bg-gray-50" data-id="element-2255" data-mp="1ymigjhdlw7r8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2256" data-mp="1un9mebenm7v5">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center" data-id="element-2257" data-mp="1uknc440dpe98">
            Этапы имплантации в Dentico Clinic
          </h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-2258" data-mp="2kouu73i59ay">
            {[{
            step: '01',
            title: 'Консультация',
            desc: 'Осмотр, 3D-диагностика (КТ) и составление детального плана лечения.'
          }, {
            step: '02',
            title: 'Установка',
            desc: 'Хирургический этап установки импланта под местной анестезией.'
          }, {
            step: '03',
            title: 'Заживление',
            desc: 'Период остеоинтеграции (приживления), который длится от 3 до 6 месяцев.'
          }, {
            step: '04',
            title: 'Протезирование',
            desc: 'Установка постоянной керамической коронки на имплант.'
          }].map((item, idx) => <Card key={idx} className="p-6 relative overflow-hidden" data-id="element-2259" data-mp="151i99fq8om5a" data-mpi={idx}>
                <div className="text-6xl font-bold text-[#EFE8DE] absolute -top-4 -right-4 select-none" data-id="element-2260" data-mp="2ph6mfd4hs4qv">
                  {item.step}
                </div>
                <div className="relative z-10" data-id="element-2261" data-mp="2frd8w6kshfjz">
                  <h3 className="text-xl font-bold text-[#2B2D2F] mb-3" data-id="element-2262" data-mp="2fq272cawmhvi">
                    {item.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-2263" data-mp="25tqr9cc3v9wb">{item.desc}</p>
                </div>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 4. WHO NEEDS IMPLANTS */}
      <section className="py-16 bg-white" data-id="element-2264" data-mp="1wt0zcjpyu3nv">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2265" data-mp="1wu3n4irzrpzk">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-2266" data-mp="1ru7jikn7i0kj">
            <div data-id="element-2267" data-mp="1rw27k7try8su">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-2268" data-mp="3r71w8z1ygglb">
                Кому подходит имплантация?
              </h2>
              <ul className="space-y-4" data-id="element-2269" data-mp="3m7pcwoaalrnh">
                {['Отсутствие одного или нескольких зубов', 'Желание отказаться от съемных протезов', 'Разрушение мостовидных конструкций', 'Необходимость восстановления жевательной функции', 'Эстетические дефекты зубного ряда'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-2270" data-mp="2euoidebkjgvw" data-mpi={idx}>
                    <CheckCircle2 className="w-6 h-6 text-forest-600 flex-shrink-0 mt-0.5" data-id="element-2271" data-mp="206lb81lshz5i" />
                    <span className="text-gray-700 text-lg" data-id="element-2272" data-mp="24xa49ld4b46r">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-8" data-id="element-2273" data-mp="1r6oldwnnyu8v">
                <Link to="/ru/contact" data-id="element-2274" data-mp="1r7q8izhyf76y">
                  <Button size="lg" className="gap-2 !opacity-100 !bg-[#2F4A3F] !text-white !border !border-[#2F4A3F] hover:!bg-[#3A5A4D]" data-id="element-2275" data-mp="1w4qdf732i3wh">
                    <Calendar className="w-5 h-5" data-id="element-2276" data-mp="1m6iz6w05xzy6" />
                    Записаться на консультацию
                  </Button>
                </Link>
              </div>
            </div>
            <div className="relative h-[400px] rounded-2xl overflow-hidden shadow-xl" data-id="element-2277" data-mp="yjf2oxjl4j8g">
              <img src="https://images.unsplash.com/photo-1606811841689-23dfddce3e95?auto=format&fit=crop&w=1200&q=80" alt="Дентальная имплантация процесс" className="absolute inset-0 w-full h-full object-cover" data-id="element-2278" data-mp="yli042n2hen7" />
            </div>
          </div>
        </div>
      </section>

      {/* 5. BENEFITS */}
      <section className="py-16 bg-[#EFE8DE]" data-id="element-2279" data-mp="1hhhwrqqzp6d4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2280" data-mp="1v9odbdy21fd3">
          <div className="text-center mb-12" data-id="element-2281" data-mp="1v965dk215cpc">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-2282" data-mp="1qav0zoui7uei">
              Преимущества имплантации в Dentico Clinic
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-2283" data-mp="258n9vy5jpkjq">
              Мы используем передовые технологии и материалы для наилучшего
              результата.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2284" data-mp="27da7iptukv1b">
            {[{
            icon: Scan,
            title: 'Цифровое планирование',
            desc: 'Точное 3D-моделирование операции для предсказуемого результата.'
          }, {
            icon: UserCheck,
            title: 'Опытная команда',
            desc: 'Врачи с многолетним опытом в хирургической стоматологии.'
          }, {
            icon: Languages,
            title: 'Русский язык',
            desc: 'Полное понимание и комфортная коммуникация на родном языке.'
          }, {
            icon: ShieldCheck,
            title: 'Гарантия качества',
            desc: 'Используем только сертифицированные импланты мировых брендов.'
          }, {
            icon: Clock,
            title: 'Экономия времени',
            desc: 'Оптимизированные протоколы лечения для вашего комфорта.'
          }, {
            icon: MapPin,
            title: 'Удобная локация',
            desc: 'Центр Лондона, 5 минут от станции метро Angel.'
          }].map((item, idx) => <Card key={idx} className="p-6 bg-white" data-id="element-2285" data-mp="odje5vyxkm6i" data-mpi={idx}>
                <div className="w-12 h-12 bg-[#F8F5F0] rounded-full flex items-center justify-center text-[#2F4A3F] mb-4 border border-[#D8C4A8]" data-id="element-2286" data-mp="of48bkhc233u">
                  <item.icon className="w-6 h-6" data-id="element-2287" data-mp="1h1f7qrt7dxz2" />
                </div>
                <h3 className="text-lg font-bold text-[#2B2D2F] mb-2" data-id="element-2288" data-mp="1h044qu7l0u90">
                  {item.title}
                </h3>
                <p className="text-gray-600" data-id="element-2289" data-mp="1740zhfhfofhu">{item.desc}</p>
              </Card>)}
          </div>
        </div>
      </section>

      {/* 6. FAQ */}
      <section className="py-16 bg-white" data-id="element-2290" data-mp="p01z5crfp95">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2291" data-mp="3rti1g0m0kvzc">
          <div className="text-center mb-10" data-id="element-2292" data-mp="3rwcn1vgrkmuc">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-2293" data-mp="lchrnkieouua">
              Частые вопросы об имплантации
            </h2>
          </div>
          <div className="space-y-2" data-id="element-2294" data-mp="q9rfivq5cyg0">
            {faqs.map((faq, idx) => <AccordionItem key={idx} question={faq.q} answer={faq.a} isOpen={openFaqIndex === idx} onToggle={() => toggleFaq(idx)} data-id="element-2295" data-mp="cdnpzfq7xe9v" data-mpi={idx} />)}
          </div>
        </div>
      </section>

      {/* 7. INTERNAL LINKS */}
      <section className="py-12 bg-gray-50 border-t border-gray-100" data-id="element-2296" data-mp="194g78gow1cd8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2297" data-mp="va5rupys6uju">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-2298" data-mp="zc0pnkhi6psv">
            Смотрите также
          </h2>
          <div className="flex flex-wrap gap-4" data-id="element-2299" data-mp="1n1v240xwuccl">
            <Link to="/ru/russkij-stomatolog-london" data-id="element-2300" data-mp="1n00g0jawke6x">
              <Button variant="outline" size="sm" data-id="element-2301" data-mp="1rt39ysjldpnn">
                Русскоязычный стоматолог
              </Button>
            </Link>
            <Link to="/ru/services/crowns" data-id="element-2302" data-mp="3chfivwgy7kd7">
              <Button variant="outline" size="sm" data-id="element-2303" data-mp="37kf9bbkw3zhc">
                Коронки
              </Button>
            </Link>
            <Link to="/ru/services/hygiene" data-id="element-2304" data-mp="3m9bixd2lhkk2">
              <Button variant="outline" size="sm" data-id="element-2305" data-mp="3mb4pksd7k4s2">
                Гигиена
              </Button>
            </Link>
            <Link to="/ru/prices" data-id="element-2306" data-mp="3hcbe15hhenuj">
              <Button variant="outline" size="sm" data-id="element-2307" data-mp="2tjl2uyhek8lb">
                Цены
              </Button>
            </Link>
            <Link to="/ru/contact" data-id="element-2308" data-mp="2omcqjeixqyrz">
              <Button variant="outline" size="sm" data-id="element-2309" data-mp="2one7u0qjohi5">
                Контакты
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* 8. CTA */}
      <section className="py-16 bg-forest-900" data-id="element-2310" data-mp="2yi62avotyo8p">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-2311" data-mp="irtms2w6q1zh">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4" data-id="element-2312" data-mp="iufty1f5yfh6">
            Верните себе уверенную улыбку
          </h2>
          <p className="text-xl text-ivory/80 mb-8 max-w-2xl mx-auto" data-id="element-2313" data-mp="1ch6nxmg2fqop">
            Запишитесь на консультацию по имплантации сегодня.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-2314" data-mp="17jy6jo2qrqoi">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2315" data-mp="1lj7ksi7e0apu">
              <Button size="lg" className="w-full gap-2 !opacity-100 !bg-[#F8F5F0] !text-[#2F4A3F] !border !border-[#F8F5F0] hover:!bg-[#EFE8DE]" data-id="element-2316" data-mp="1vg2feq0jhqyu">
                <Calendar className="w-5 h-5" data-id="element-2317" data-mp="248e68czkfgfc" />
                Записаться онлайн
              </Button>
            </a>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto" data-id="element-2318" data-mp="206sooec36dyt">
              <Button size="lg" className="w-full gap-2 !opacity-100 !bg-[#EFE8DE] !text-[#2F4A3F] !border !border-[#D8C4A8] hover:!bg-[#2F4A3F] hover:!text-white" data-id="element-2319" data-mp="297z6cqqh1utn">
                <MessageCircle className="w-5 h-5" data-id="element-2320" data-mp="2xt5a2r8oaj41" />
                WhatsApp
              </Button>
            </a>
          </div>
        </div>
      </section>
    </Layout>;
}